import React, { useEffect, useState } from "react";
import "./badge.css";
// import Banner from "./assets/Symposium-banner-1.jpg";
import Banner from "./assets/Symposium-banner-2026.jpg";
// import Badge from "./assets/Symposium_Badges_curved.png";
// import Badge from "./assets/Symposium_Badge.png";
import Badge from "./assets/Symposium_Badge_2026.png";
import axios from "axios";
import { useParams } from "react-router-dom";

const Ebadge = () => {
  const [data, setData] = useState({});
  const { id } = useParams();
  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/form/visitor/${id}`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching visitor details:", error);
      }
    };

    fetchDetails();
  }, [id]);

  return (
    <div className="email-container">
      {/* Banner Section */}
      <div className="email-banner">
        <img src={Banner} alt="Symposium Banner" className="email-banner-img" />
      </div>

      {/* Email Content */}
      <div className="email-body">
        <p
          style={{
            marginBottom: "10px",
          }}
        >
          <strong>
            Dear {data.firstName} {data.lastName},
          </strong>
        </p>
        <p>
          You have been registered for the{" "}
          <strong>Symposium on Automation & Robotics 2026</strong>!
        </p>

        {/* Badge Section (with QR code) */}
        <div className="badge-display">
          <div className="badge-wrapper">
            <img src={Badge} alt="Visitor Badge" className="badge-image" />
            <div className="badge-overlay">
              <div className="badge-name">
                {`${data?.firstName?.toUpperCase() || ""} ${
                  data?.lastName?.toUpperCase() || ""
                }`}
              </div>
              <div className="badge-company">{data.companyName}</div>

              <div>
                <img
                  src={data.qrCode}
                  alt="Visitor QR Code"
                  style={{
                    width: "100px",
                    height: "100px",
                    border: "1px solid #ccc",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Info Section */}
        <p>
          This registration enables you to have quick and safe entry to the
          exhibition venue only.
        </p>

        <h4
          style={{
            marginTop: "40px",
          }}
        >
          For your information:
        </h4>
        <ul>
          <li>
            Date of the exhibition:<strong> 13 - 14 August 2026</strong>
          </li>
          <li>
            Venue:<strong> Conference Centre, BIEC, Bangalore</strong>
          </li>
          <li>
            Address:{" "}
            <strong>
              Indian Machine Tool Manufacturers’ Association, BIEC, 10th Mile Tumkur Road, Bangalore 562162
            </strong>
          </li>
          <li>
            Exhibition Days:
            <strong> 13 August 2026, (Thursday) – 14 August 2026, (Friday)</strong>
          </li>
          <li>
            Visiting Time: <strong>10:00 a.m. to 5:00 p.m.</strong>
          </li>
          <li
            style={{
              marginBottom: "10px",
            }}
          >
            Google maps to reach the venue:{" "}
            <a
              href="https://maps.app.goo.gl/D1LLX4Ro8nYCz6vMA"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://maps.app.goo.gl/D1LLX4Ro8nYCz6vMA
            </a>
          </li>
        </ul>

        <p>
          For the latest event information, schedules, and content, please visit
          :{" "}
          <a
            href="https://www.imtma.in/automation"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.imtma.in/automation
          </a>
        </p>

        <h4
          style={{
            marginTop: "40px",
          }}
        >
          Rules & Regulations:
        </h4>
        <ul>
          <li>
            This badge must be always worn & displayed continuously at the venue
            and the respective key areas.
          </li>
          <li>
            Children below the age of 18 years will not be allowed to attend the
            exhibition on all four days, and organizers will not bear the
            responsibility for the same.
          </li>
          <li>
            Organizers will not be responsible for theft and damage to valuables
            and property. brought to the fair ground. You will be solely
            responsible for your belongings.
          </li>
          <li>
            Visitors may be subjected to security checks at any given point.
            (Kindly cooperate)
          </li>
        </ul>
        <br />
        <p>
          <strong>
            <mark>
              Note: You may register separately for the Symposium Conference
              through the below mentioned link (Paid Conference)
            </mark>
          </strong>
        </p>
        <br />

        <p>
          <a
            href="https://www.imtma.in/automation/delegate_registration"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.imtma.in/automation/delegate_registration
          </a>
        </p>

        <p
          style={{
            marginTop: "40px",
          }}
        >
          See you at the event!
          <br />
          <strong>Team IMTMA</strong>
        </p>
      </div>
    </div>
  );
};

export default Ebadge;
